import React from 'react';
import styled from '@emotion/native';
import { green } from '@/shared/styles/colors';
import { IsDesktopProps } from '@/shared/styles/types';
import useIsDesktop from '@/shared/hooks/useIsDesktop';
import { useNavigation, useRouter } from 'expo-router';
import { ROUTES } from '@/shared/constants/routes';
import OnboardingCompleteButtons from '@/app/client-onboarding/components/OnboardingCompleteButtons';
import { useApollo } from '@/services/apollo/ApolloProvider';

import Progress from './Progress';
import {
  stylistOnboardingDescriptionTextOptions,
  stylistOnboardingTitleTextOptions,
} from '../../../components/onboarding/onboardingContent';
import OnboardingHeader from '@/shared/components/navigation/OnboardingHeader';
import { useScrollToTop } from '@/shared/hooks/useScrollToTop';
import ScrollableView from '@/shared/components/ScrollableView';
import { NavigationProp, ParamListBase } from '@react-navigation/native';
import { resetNavigationToRoute } from '@/shared/utils';

const StylistOnboardingComplete = () => {
  const isDesktop = useIsDesktop();
  const router = useRouter();
  const { logOut } = useApollo();
  const scrollToTop = useScrollToTop();
  const navigation = useNavigation<NavigationProp<ParamListBase>>();
  const onLogoPress = () => {
    scrollToTop();
    router.replace(ROUTES.PREVIEW.path);
  };

  const lastStepNumber =
    Object.keys(stylistOnboardingTitleTextOptions).length - 1;

  return (
    <Container
      contentContainerStyle={{
        paddingTop: 20,
        alignItems: 'center',
      }}
    >
      <OnboardingHeader
        progress={lastStepNumber}
        showDarkColors={false}
        hideBackButton={true}
        onPress={() => logOut()}
        authText="Log Out"
        onLogoPress={onLogoPress}
      />
      <Spacer isDesktop={isDesktop} />
      <Progress
        progress={lastStepNumber}
        titleText={stylistOnboardingTitleTextOptions}
        descriptionContent={stylistOnboardingDescriptionTextOptions}
        altStyle={true}
        isRequired={false}
        showCenteredView={true}
      />
      <InnerContainer isDesktop={isDesktop}>
        <OnboardingCompleteButtons
          onFirstButtonClick={() => {
            resetNavigationToRoute(navigation, ROUTES.PREVIEW.name);
          }}
          onSecondButtonClick={() => {
            resetNavigationToRoute(navigation, ROUTES.SESSIONS.name);
          }}
          firstButtonText="View Profile"
          secondButtonText="Go To Home"
        />
      </InnerContainer>
    </Container>
  );
};

const Container = styled(ScrollableView)({
  flex: 1,
  backgroundColor: green,
});

const InnerContainer = styled.View<IsDesktopProps>(({ isDesktop }) => ({
  paddingHorizontal: isDesktop ? 40 : 24,
  width: '100%',
}));

const Spacer = styled.View<IsDesktopProps>(({ isDesktop }) => ({
  height: isDesktop ? 109 : 0,
  width: '100%',
}));

export default StylistOnboardingComplete;
